import React from "react";
import { useSearchParams } from "react-router-dom";
import Integration from "@/model/interface/Integration";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import InvestorFuseSettings from "./InvestorFuseSettings";
import IntegrationSyncLog from "../IntegrationSyncLog";

const TABS = ["settings", "sync-log"] as const;
type Tab = (typeof TABS)[number];

interface Props {
  integration: Integration;
}

export default function InvestorFuseDetail({ integration }: Props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const activeTab: Tab = TABS.includes(tabParam as Tab) ? (tabParam as Tab) : "settings";

  const setTab = (tab: string) => {
    setSearchParams({ tab }, { replace: true });
  };

  return (
    <Tabs value={activeTab} onValueChange={setTab}>
      <TabsList>
        <TabsTrigger value="settings">Settings</TabsTrigger>
        <TabsTrigger value="sync-log">Sync Log</TabsTrigger>
      </TabsList>

      <TabsContent value="settings" className="mt-6">
        <InvestorFuseSettings integration={integration} />
      </TabsContent>

      <TabsContent value="sync-log" className="mt-6">
        <IntegrationSyncLog integrationId={integration.id} />
      </TabsContent>
    </Tabs>
  );
}
